export default "__VITE_ASSET__be816572__"